// CUSTOM STEPPER COMPONENT

import * as React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import WorkIcon from '@mui/icons-material/Work';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import EngineeringIcon from '@mui/icons-material/Engineering';
const CustomConnector = styled(StepConnector)(({ theme }) => ({

    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 22,
    },
    [`&.${stepConnectorClasses.active}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            backgroundImage:
                'linear-gradient( 95deg,rgb(33,150,243) 0%,rgb(76,175,80) 50%,rgb(255,193,7) 100%)',
        },
    },
    [`&.${stepConnectorClasses.completed}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            backgroundImage:
                'linear-gradient( 95deg,rgb(33,150,243) 0%,rgb(76,175,80) 50%,rgb(255,193,7) 100%)',
        },
    },
    [`& .${stepConnectorClasses.line}`]: {
        height: 3,
        border: 0,
        backgroundColor: '#eaeaf0',
        borderRadius: 1,
    },
}));

const CustomStepIconRoot = styled('div')(({ theme }) => ({
    backgroundColor: '#ccc',
    zIndex: 1,
    color: '#fff',
    width: 50,
    height: 50,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    variants: [
        {
            props: ({ ownerState }) => ownerState.active,
            style: {
                backgroundImage:
                    'linear-gradient( 136deg, rgb(33,150,243) 0%, rgb(76,175,80) 50%, rgb(255,193,7) 100%)',
                boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
            },
        },
        {
            props: ({ ownerState }) => ownerState.completed,
            style: {
                backgroundImage:
                    'linear-gradient( 136deg, rgb(33,150,243) 0%, rgb(76,175,80) 50%, rgb(255,193,7) 100%)',
            },
        },
    ],
}));

function CustomStepIcon(props) {
    const { active, completed, className, onClick, userId } = props;

    const icons = {
        1: <EngineeringIcon />, // First step
        2: <WorkIcon />, // Second step
        3: <DoneAllIcon />, // Third step
    };

    return (
        <CustomStepIconRoot ownerState={{ completed, active, userId }} className={className} onClick={userId ? onClick : undefined} style={{ cursor: userId ? 'pointer' : '' }} >
            {icons[String(props.icon)]}
        </CustomStepIconRoot>
    );
}

CustomStepIcon.propTypes = {
    active: PropTypes.bool,
    className: PropTypes.string,
    completed: PropTypes.bool,
    icon: PropTypes.node,
    userId: PropTypes.any,
    onClick: PropTypes.func,
};


export default function CustomStepper({ activeStep, steps, handleNextStep, userId }) {
    return (
        <Stack sx={{ width: '100%' }} spacing={4}>
            <Stepper alternativeLabel activeStep={activeStep} connector={<CustomConnector />}>
                {steps.map((label, index) => (
                    <Step key={label}>
                        <StepLabel
                            StepIconComponent={(props) => (
                                <CustomStepIcon
                                    {...props}
                                    userId={userId}
                                    onClick={() => userId && handleNextStep(index)}
                                />
                            )}
                        >
                            {label}
                        </StepLabel>
                    </Step>
                ))}
            </Stepper>
        </Stack>
    );
}